/**
 * Module Configuration Index
 * Registers all platform modules with the module registry.
 * This file should be imported early in the application lifecycle.
 */

import { registerModule } from '../moduleRegistry';
import { surveyModuleConfig } from './survey.config';
import { examModuleConfig } from './exam.config';

/**
 * Initializes and registers all modules.
 * Call this once during application startup, before ModuleProvider mounts.
 */
export function initializeModules(): void {
  try {
    // Register survey module
    registerModule(surveyModuleConfig);
    console.log('✓ Survey module registered');

    // Register exam module
    registerModule(examModuleConfig);
    console.log('✓ Exam module registered');

    console.log('✓ All modules registered successfully');
  } catch (error) {
    console.error('Failed to register modules:', error);
    throw error;
  }
}

// Export module configs for direct access if needed
export { surveyModuleConfig, examModuleConfig };
